import React, { Component } from 'react';

// import axios from 'axios';

class userAccessControl extends Component {
	componentDidMount() {
		sessionStorage.setItem('userTime', 0);
        
        this.setUserPost();
	}

	setUserPost = () => {
		setInterval(() => {
            const $pixel = document.querySelector('.pixel');

            if (!!sessionStorage.getItem('sessionToken') && !!$pixel) {
                let $time = Number(sessionStorage.getItem('userTime'));

                $time += 5;
    
                sessionStorage.setItem('userTime', $time);
    
                const $method = $time < 10 ? 'post' : 'put';
    
                this.submit($method, $time);
            }
		}, 5000);
	};

	submit = (type, $time) => {
		const $account = sessionStorage.getItem('msisdn');
		let $data = {
			msisdn: $account,
			time: $time,
			platform_id: 2
		};

		fetch("https://api.oston.io/clicnoticia/v1/logs", { method: type, body: JSON.stringify($data), headers: new Headers({'content-type': 'application/json'}) }).then(function (res) { 
			//console.log(res) 
		}).catch(function (res) { 
			//console.log(res)
		 })

	};

	render() {
		return <div className="pixel" />;
	}
}

export default userAccessControl;



// WEBPACK FOOTER //
// ./src/userAccessControl.js